export default "__VITE_ASSET__737e12d8__"